import React from "react";
import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import SidePanelLayout from "@ui/SidePanel/Layout";
import Secondary from "@ui/Header/Secondary";
import NavV2 from "@ui/NavV2";
import Tab from "@ui/NavV2/Tab";
import { useCanUserDo } from "../../canUserDo";
import { Outlet, useLocation } from "react-router";
import { toPath } from "../../../router/helpers/path";
import t from "../../../i18n";
import ProcessesDashboard from "./ProcessesDashboard";
import CacDashboard from "./CacDashboard";

export function AdministrationProcesses() {
  const canManageApplicationSettings = useCanUserDo("ADMIN_SETTING_MANAGE");
  const canManageProcesses = useCanUserDo("PROCESS_MANAGE");
  const location = useLocation();

  return (
    <SidePanelLayout className={panelMain}>
      <Secondary
        className={secondary}
        nav={
          <NavV2>
            {canManageProcesses && (
              <Tab
                to={toPath("/administration/processes/monitoring", {})}
                active={location.pathname.includes("/administration/processes/monitoring")}
              >
                {t("administration.processes.subtab.monitoring")}
              </Tab>
            )}
            {canManageApplicationSettings && (
              <Tab
                to={toPath("/administration/processes/trigger", {})}
                active={location.pathname.includes("/administration/processes/trigger")}
              >
                {t("administration.processes.subtab.trigger")}
              </Tab>
            )}
          </NavV2>
        }
      />
      <SidePanelLayout className={content}>
        <Outlet />
      </SidePanelLayout>
    </SidePanelLayout>
  );
}

export { ProcessesDashboard, CacDashboard };

const panelMain = css`
  gap: 0;
  padding: 0 !important;
`;

const content = css`
  gap: 0;
  padding: ${spacings.l} ${spacings.xxl} ${spacings.l} ${spacings.xxl} !important;
`;

const secondary = css`
  padding: 0 ${spacings.xxl};
`;
